export enum LossOfEligibilityValues {
	Manual = 'manual',
	DayFollowing = 'day_following',
	MonthFollowing = 'month_following',
}
